import React from 'react';
import { Printer } from 'lucide-react';

const PrintPurchaseFormButton = ({ typeOfRequest }) => {
  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const currentDate = new Date().toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    // Determinar el título según el tipo de solicitud
    const getTitle = () => {
      return typeOfRequest === 'purchase' 
        ? 'Formulario Solicitud de Compra'
        : 'Formulario Solicitud Contrato de Servicio';
    };
    
    // Obtener todos los elementos a imprimir
    let infoRequest = document.querySelector('.info-request').cloneNode(true);
    let descriptionAction = document.querySelector('.description-action').cloneNode(true);
    let additionalInfo = document.querySelector('.additional-info').cloneNode(true);
    let purchaseDetails = document.querySelector('.purchase-details').cloneNode(true);
    let attachments = document.querySelector('.attachments').cloneNode(true);
    
    // Crear el HTML para impresión
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${getTitle()}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              font-size: 10px;
              margin: 0;
              padding: 10px;
              width: 100%;
              box-sizing: border-box;
            }

            .subtitle {
              color: #5664D2;
              font-weight: bold;
              font-size: 11px;
              margin: 10px 0 5px 0;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 15px;
              table-layout: fixed;
            }

            th, td {
              border: 1px solid #ddd;
              padding: 6px 4px;
              height: 20px;
              line-height: 1.2;
              overflow: hidden;
              text-align: left;
              vertical-align: middle;
            }

            th {
              background-color: #5664D2 !important;
              color: white !important;
              font-weight: bold;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              font-size: 9px;
              text-align: center;
              height: 25px;
            }

            /* Estilos para la tabla de info-request */
            .table-info-request th:nth-child(1) { width: 10%; } /* Folio */
            .table-info-request th:nth-child(2) { width: 15%; } /* Fecha */
            .table-info-request th:nth-child(3) { width: 30%; } /* Establecimiento */
            .table-info-request th:nth-child(4) { width: 10%; } /* RBD */
            .table-info-request th:nth-child(5) { width: 15%; } /* Año */
            .table-info-request th:nth-child(6) { width: 20%; } /* Subvención */

            .table-info-request td {
              text-align: center;
            }

            /* Estilos para la tabla de description-action */
            .description-action-box table th:nth-child(1) { width: 20%; } /* Dimensión */
            .description-action-box table th:nth-child(2) { width: 35%; } /* Nombre Acción */
            .description-action-box table th:nth-child(3) { width: 25%; } /* Clasificación */
            .description-action-box table th:nth-child(4) { width: 20%; } /* Cuenta */

            .description-action-box table td {
              text-align: center;
            }

            /* Estilos para la tabla de additional-info */
            .additional-info-box table th:nth-child(1) { width: 40%; } /* Responsable */
            .additional-info-box table th:nth-child(2) { width: 20%; } /* Teléfono */
            .additional-info-box table th:nth-child(3) { width: 40%; } /* Cargo */

            .additional-info-box table td {
              text-align: center;
            }

            /* Estilos para la tabla de purchase-details */
            .purchase-details table th:nth-child(1) { width: 5%; text-align: center; }  /* Item */
            .purchase-details table th:nth-child(2) { width: 50%; text-align: center; } /* Detalle */
            .purchase-details table th:nth-child(3) { width: 10%; text-align: center; } /* Cantidad */
            .purchase-details table th:nth-child(4) { width: 15%; text-align: center; } /* Valor Unitario */
            .purchase-details table th:nth-child(5) { width: 20%; text-align: center; } /* Valor Total */

            .purchase-details table td:nth-child(1) { text-align: center; }
            .purchase-details table td:nth-child(2) { text-align: left; padding-left: 10px; }
            .purchase-details table td:nth-child(3) { text-align: center; }
            .purchase-details table td:nth-child(4) { text-align: right; padding-right: 10px; }
            .purchase-details table td:nth-child(5) { text-align: right; padding-right: 10px; }

            /* Estilos para las secciones de observaciones y justificación */
            .details-section {
              margin: 10px 0;
              padding: 5px;
            }

            .details-title {
              color: #5664D2;
              font-weight: bold;
              font-size: 10px;
              margin-bottom: 5px;
            }

            .details-content {
              border: 1px solid #ddd;
              padding: 8px;
              margin-top: 3px;
              min-height: 20px;
              line-height: 1.4;
            }

            .attachments {
              margin-top: 15px;
              padding-top: 10px;
              border-top: 1px solid #ddd;
            }

            .attachments span {
              margin: 5px 0;
            }

            .attachments p {
              margin: 2px 0;
              color: #5664D2;
              font-weight: bold;
            }

            .attachments ul {
              list-style: none;
              padding-left: 20px;
              margin: 2px 0;
            }

            .attachments a {
              color: #5664D2;
              text-decoration: none;
            }

            tfoot td {
              font-weight: bold;
              background-color: rgba(86, 100, 210, 0.1) !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            tfoot td:last-child {
              text-align: right;
              padding-right: 10px;
            }

            .footer {
              position: fixed;
              bottom: 0;
              left: 0.5cm;
              right: 0.5cm;
              padding: 5px 0;
              border-top: 1px solid #ddd;
              font-size: 8px;
              color: #666;
              text-align: center;
              background-color: white;
            }

            @media print {
              @page {
                size: portrait;
                margin: 0.5cm;
                margin-bottom: 1cm;
              }

              td {
                white-space: normal;
              }

              .footer {
                position: fixed;
                bottom: 0;
              }
            }
          </style>
        </head>
        <body>
          <h1 style="color: #5664D2; font-size: 14px; margin-bottom: 10px; text-align: center; font-weight: bold;">
            ${getTitle()}
          </h1>
          ${infoRequest.outerHTML}
          ${descriptionAction.outerHTML}
          ${additionalInfo.outerHTML}
          ${purchaseDetails.outerHTML}
          ${attachments.outerHTML}
          <div class="footer">
            <span>Solicitud ${typeOfRequest === 'purchase' ? 'de compra' : 'de servicios'} creada: ${currentDate}</span>
          </div>
          <script>
            window.onload = () => {
              setTimeout(() => {
                window.print();
                window.onafterprint = () => window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
  };

  return (
    <button
      onClick={handlePrint}
      className='btn-inform flex'
      title="Imprimir formulario"
    >
      <Printer color="white" size={20} />
      <p>Imprimir Formulario</p>
    </button>
  );
};

export default PrintPurchaseFormButton;